module.exports = __webpack_public_path__ + "img/置顶演示.2e29ada8.gif";